import { render, staticRenderFns } from "./AdminDashBoard.vue?vue&type=template&id=e7f24bf6&"
import script from "./AdminDashBoard.vue?vue&type=script&lang=js&"
export * from "./AdminDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports